import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {
	emailValidatation,
	firstNameValidatation,
	lastNameValidatation,
} from '../../Utils/Utils';

//save design   model content
export const SaveDesignModal = (props) => {
	const retrievedSavedesignformdata = JSON.parse(
		localStorage.getItem('savedesignformdata')
	);
	const [isDisabled, setIsDisabled] = useState(true);

	const [email, setEmail] = useState(
		retrievedSavedesignformdata != null ? retrievedSavedesignformdata.email : ''
	);
	const [firstname, setFirstname] = useState(
		retrievedSavedesignformdata != null
			? retrievedSavedesignformdata.firstname
			: ''
	);
	const [lastname, setLastname] = useState(
		retrievedSavedesignformdata != null
			? retrievedSavedesignformdata.lastname
			: ''
	);
	const [specialoffers, setSpecialoffers] = useState(
		retrievedSavedesignformdata != null
			? retrievedSavedesignformdata.specialoffers
			: false
	);
	const [errors, setErrors] = useState({});
	const [fnameerrors, setFirstNameErrors] = useState({});
	const [lnameerrors, setLastNameErrors] = useState({});

	useEffect(() => {
		email &&
		firstname &&
		lastname &&
		!document.getElementsByClassName('text-danger').length > 0
			? setIsDisabled(false)
			: setIsDisabled(true);
	}, [errors, fnameerrors, lnameerrors, email, firstname, lastname]);
	const disableSaveEmailDesignBtn = () => {
		document.getElementsByClassName('text-danger').length > 0
			? setIsDisabled(true)
			: setIsDisabled(false);
	};
	return (
		<Modal {...props} dialogClassName='modal-md modal-box' className="save-your-design" backdrop="static" keyboard={false}>
			<Modal.Header
				closeButton
				className='modal-header border-0'>	
					<h4>
					{props.stolemeta &&
						props.stolemeta.saveDesignPopUp &&
						props.stolemeta.saveDesignPopUp.title}
				</h4>			
				</Modal.Header>
			<Modal.Body>			
				<p>
					{props.stolemeta &&
						props.stolemeta.saveDesignPopUp &&
						props.stolemeta.saveDesignPopUp.info}
				</p>
				<form>
					<div className='form-group col-xs-12'>
						<label htmlFor='email'>
							{props.stolemeta &&
								props.stolemeta.saveDesignPopUp &&
								props.stolemeta.saveDesignPopUp.emailLabel}
						</label>
						<input
							type='email'
							className='form-control'
							name='email'
							id='email'
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							onBlur={(e) => {
								emailValidatation(e, setErrors, props.stolemeta.saveDesignPopUp);
								disableSaveEmailDesignBtn();
							}}
						/>
						{errors.email && <div className='text-danger'>{errors.email}</div>}
					</div>

					<div className='form-group col-xs-12'>
						<label htmlFor="firstname">
							{props.stolemeta &&
								props.stolemeta.saveDesignPopUp &&
								props.stolemeta.saveDesignPopUp.fnameLabel}
						</label>
						<input
							type='text'
							className='form-control'
							name='firstname'
							id='firstname'
							value={firstname}
							onChange={(e) => setFirstname(e.target.value)}
							onBlur={(e) => {
								firstNameValidatation(e, setFirstNameErrors, props.stolemeta.saveDesignPopUp);
								disableSaveEmailDesignBtn();
							}}
						/>
						{fnameerrors.firstname && (
							<div className='text-danger'>{fnameerrors.firstname}</div>
						)}
					</div>

					<div className='form-group col-xs-12'>
						<label htmlFor="lastname">
							{props.stolemeta &&
								props.stolemeta.saveDesignPopUp &&
								props.stolemeta.saveDesignPopUp.lnameLabel}
						</label>
						<input
							type='text'
							className='form-control'
							name='lastname'
							id='lastname'
							value={lastname}
							onChange={(e) => setLastname(e.target.value)}
							onBlur={(e) => {
								lastNameValidatation(e, setLastNameErrors, props.stolemeta.saveDesignPopUp);
								disableSaveEmailDesignBtn();
							}}
						/>
						{lnameerrors.lastname && (
							<div className='text-danger'>{lnameerrors.lastname}</div>
						)}
					</div>

					<div className='form-group col-xs-12 checkbox-desc'>
						<input
							type='checkbox'
							id='checked-offer-value'
							value={specialoffers}
							checked={specialoffers}
							onChange={(e) => setSpecialoffers(e.target.checked)}
						/>
						<label className='offertext' htmlFor='checked-offer-value'>
							{props.stolemeta &&
								props.stolemeta &&
								props.stolemeta.saveDesignPopUp.concentText}
						</label>
					</div>

					<Button
						className="modal-btn"
						onClick={() =>
							props.savedesign(email, firstname, lastname, specialoffers)
						}
						data-test='savedesign'
						variant={isDisabled?"black":"white"}
						disabled={isDisabled}
						>
						{props.stolemeta &&
							props.stolemeta.saveDesignPopUp &&
							props.stolemeta.saveDesignPopUp.saveBtn}
					</Button>
				</form>
			</Modal.Body>
		</Modal>
	);
};
